import { render, staticRenderFns } from "./downloadZip.vue?vue&type=template&id=061c8eca"
import script from "./downloadZip.vue?vue&type=script&lang=js"
export * from "./downloadZip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports